"use client";
import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function HeroSection() {
  return (
    <section
      id="home-hero"
      className="relative overflow-hidden text-primary-foreground dark:text-foreground transition-colors duration-300"
      data-header-scheme="light"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <Image
          src="/images/home/hero-2.png"
          alt="Plaster finish texture background"
          fill
          priority
          placeholder="empty"
          sizes="100vw"
          className="object-cover object-center filter-[brightness(0.65)]"
        />
        {/* Overlay gradient for readability */}
        {/* <div className="absolute inset-0 bg-linear-to-b from-black/10 via-transparent to-black/10 " /> */}
        {/* <div className="absolute inset-0 bg-linear-to-tr from-black/10 via-transparent to-black/10 " /> */}
      </div>
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-32 lg:py-40 bg-transparent">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-light mb-8 leading-tight tracking-tight drop-shadow-[0_4px_12px_rgba(0,0,0,0.6)]">
            Learn Plaster Finishes.
            <span className="block font-light italic text-stone-300">
              Get Hired Faster.
            </span>
          </h1>
          <p className="font-sans text-xl md:text-2xl mb-12 max-w-4xl mx-auto leading-relaxed drop-shadow-[0_2px_6px_rgba(0,0,0,0.65)]">
            On-demand plaster applicator courses and pro videos — plus a
            contractor directory that helps homeowners find skilled finishers.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Button
              size="lg"
              className="bg-accent text-accent-foreground hover:bg-accent/90 font-medium text-lg px-8 py-4 h-auto"
              asChild
            >
              <Link href="/courses">
                Browse Courses <ArrowRight className="ml-3 h-5 w-5" />
              </Link>
            </Button>
            <Button
              size="lg"
              variant="secondary"
              className="font-medium text-lg text-foreground px-8 py-4 h-auto"
              asChild
            >
              <Link href="/applicators">Find a Contractor</Link>
            </Button>
          </div>
        </motion.div>
      </div>
      {/* Subtle ambient shapes (toned down for photographic background) */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden>
        <div className="absolute top-1/4 left-[15%] w-80 h-80 bg-accent/10 rounded-full mix-blend-screen blur-3xl animate-pulse" />
        <div className="absolute top-1/3 right-[20%] w-72 h-72 bg-accent/10 rounded-full mix-blend-screen blur-3xl animate-pulse animation-delay-2000" />
        <div className="absolute bottom-1/4 left-1/2 w-64 h-64 bg-accent/10 rounded-full mix-blend-screen blur-3xl animate-pulse animation-delay-4000" />
      </div>
    </section>
  );
}
